document.addEventListener('DOMContentLoaded', function () {
  var table = document.querySelector('[data-comparison-table]');
  if (!table) return;

  // Stop propagation on inner modal — but NOT on close button or its children
  var inner = table.closest('[id^="comparison-inner-"]');
  if (inner) {
    inner.addEventListener('click', function(e) {
      if (!e.target.closest('[close-modal]')) {
        e.stopPropagation();
      }
    });
    inner.addEventListener('mousedown', function(e) {
      if (!e.target.closest('[close-modal]')) {
        e.stopPropagation();
      }
    });
  }

  // Handle column product selects (cols 2-4)
  var colSelects = table.querySelectorAll('[data-col-select]');
  colSelects.forEach(function(select) {
    select.addEventListener('click', function(e) { e.stopPropagation(); });
    select.addEventListener('mousedown', function(e) { e.stopPropagation(); });
    select.addEventListener('change', function(e) {
      e.stopPropagation();
      var col = this.getAttribute('data-col-select');
      var selectedHandle = this.value;

      // Switch product display in header
      var displays = table.querySelectorAll('[data-product-display="' + col + '"]');
      displays.forEach(function(d) {
        if (d.getAttribute('data-product-handle') === selectedHandle) {
          d.removeAttribute('hidden');
        } else {
          d.setAttribute('hidden', '');
        }
      });

      // Switch cell data in all rows
      var cells = table.querySelectorAll('[data-cell-product="' + col + '"]');
      cells.forEach(function(cell) {
        if (cell.getAttribute('data-product-handle') === selectedHandle) {
          cell.removeAttribute('hidden');
        } else {
          cell.setAttribute('hidden', '');
        }
      });
    });
  });
});
